// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import getRealTimeWarehouseInventory from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";
import translate from "@insite/client-framework/Translate";
import {
    AvailabilityDto,
    AvailabilityMessageType,
    ProductSettingsModel,
    WarehouseDto,
} from "@insite/client-framework/Types/ApiModels";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import { DataTableCellBaseProps } from "@insite/mobius/DataTable/DataTableCellBase";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
// import Icon, { IconWrapper } from "@insite/mobius/Icon"; // Starter Custom Code
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Check from "@insite/mobius/Icons/Check";
import X from "@insite/mobius/Icons/X";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import safeColor from "@insite/mobius/utilities/safeColor";
// import React, { useState } from "react"; // Store Custom Code
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

/* Starter Custom Code - Start */
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import { injectCss } from "@insite/mobius/utilities";
import AlertCircleFill, {
    AlertCircleFillOffset,
} from "@store/Library/Components/Toolkit/Icons/AlertCircle/AlertCircleFill";
import AlertTriangleFill, {
    AlertTriangleFillOffset,
} from "@store/Library/Components/Toolkit/Icons/AlertTriangle/AlertTriangleFill";
import CheckmarkCircle2Fill, {
    CheckmarkCircle2FillOffset,
} from "@store/Library/Components/Toolkit/Icons/CheckmarkCircle2/CheckmarkCircle2Fill";
import InfoFill from "@store/Library/Components/Toolkit/Icons/Info/InfoFill";
import Loader from "@store/Library/Components/Toolkit/Loader";
import { linkAltStyles } from "@store/Themes/common/mixins/link";
import { StatusColor, statusStyles } from "@store/Themes/common/mixins/status";
import { loadingDotsStyles } from "@store/Themes/common/mixins/typography";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

export const useShowProductAvailability = () => {
    const showInventoryToggle = useAppSelector(state => Boolean(state.context.showInventory));
    const showInventorySetting = useAppSelector(
        state => getSettingsCollection(state).productSettings.showInventoryAvailability,
    );

    return showInventoryToggle && showInventorySetting;
};
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
import { useInventoryStatus } from "@store/Framework/Common/Hooks/useInventoryStatus";
import storeConstants from "@store/storeConstants";
import { useSession, useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import React, { useMemo, useState } from "react";
/* Store Custom Code - End */

interface OwnProps {
    productId: string;
    availability?: AvailabilityDto;
    unitOfMeasure: string;
    trackInventory: boolean;
    isProductDetailsPage?: boolean;
    failedToLoadInventory?: boolean;
    extendedStyles?: ProductAvailabilityStyles;
    // Starter Custom Code
    overridedStyles?: ProductAvailabilityStyles;
    // Store Custom Code
    quantityOrdered?: number | null;
    additionalResults?: { [key: string]: string } | null;
    qtyOnHand?: number | undefined;
}

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
    showInventory: state.context.showInventory,
});

const mapDispatchToProps = {
    getRealTimeWarehouseInventory,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ProductAvailabilityStyles {
    container?: GridContainerProps;
    messageGridItem?: GridItemProps;
    availabilityByWarehouseLinkGridItem?: GridItemProps;
    inventoryMessage?: InjectableCss;
    messageText?: TypographyPresentationProps;
    realTimeText?: TypographyPresentationProps;
    errorWrapper?: InjectableCss;
    errorText?: TypographyPresentationProps;
    availabilityByWarehouseLink?: LinkPresentationProps;
    availabilityByWarehouseModal?: ModalPresentationProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    availabilityByWarehouseTable?: DataTableProps;
    availabilityByWarehouseTableHead?: DataTableHeadProps;
    availabilityByWarehouseTableHeader?: DataTableHeaderProps;
    availabilityByWarehouseTableBody?: DataTableBodyProps;
    availabilityByWarehouseTableRow?: DataTableRowProps;
    availabilityByWarehouseTableCell?: DataTableCellBaseProps;
    // Starter Custom Code
    availabilityByWarehouseIcon?: IconPresentationProps;
    wrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
    // Store Custom Code
    additionnalMessageText?: TypographyPresentationProps;
    fastTrackAvailabilityMessageText?: TypographyPresentationProps;
}

export const productAvailabilityStyles: ProductAvailabilityStyles = {
    wrapper: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    availabilityByWarehouseLink: {
        icon: {
            position: "left",
            iconProps: {
                src: InfoFill,
                size: 18,
                css: css`
                    margin-right: 0;
                    color: inherit;
                `,
            },
        },
        css: css`
            ${linkAltStyles()}
            margin-left: ${pxToRem(5)};
        `,
    },
    availabilityByWarehouseModal: {
        sizeVariant: "small",
        cssOverrides: {
            modalContent: css`
                padding: ${pxToRem(10)};
            `,
        },
    },
    availabilityByWarehouseTable: {
        css: css`
            ${x => x.theme.dataTable.defaultProps?.css}
            border: none;
        `,
    },
    messageText: {
        css: css`
            width: 100%;
            ${wrapInContainerStyles}

            /* Store Custom Code - Start */
            font-weight: ${x => x.theme.design.typography.weight.bold};
            font-size: ${x => x.theme.design.typography.size.large};
            line-height: ${x => x.theme.design.typography.lineHeight.smaller};
            /* Store Custom Code - End */
        `,
    },
    realTimeText: {
        css: loadingDotsStyles(),
    },
    // Store Custom Code
    inventoryMessage: {
        css: css`
            display: flex;
            flex-direction: column;
            padding: 0.5em 0;
        `,
    },
    additionnalMessageText: {
        css: css`
            width: 100%;
            ${wrapInContainerStyles}

            margin-top: 0.25em;
            color: ${getColor("text.accent")};
            font-weight: ${x => x.theme.design.typography.weight.base};
            font-size: ${x => x.theme.design.typography.size.base};
            margin-bottom: 1em;
        `,
    },
    fastTrackAvailabilityMessageText: {
        italic: true,
        css: css`
            display: block;
            font-style: italic;
            color: ${getColor("text.accent")};
            margin-top: ${pxToRem(1)};
            line-height: 1.25;

            ${({ theme }) => css`
                font-size: ${theme.design.typography.size.tiny};
                font-weight: ${theme.design.typography.weight.base};
            `};
        `,
    },
};

/* Starter Custom Code - Start */
const InventoryMessage = styled.div<{ _color: StatusColor; _iconOffset?: IconOffset }>`
    ${x => statusStyles(x._color, x._iconOffset)}
    ${injectCss}
`;
/* Starter Custom Code - End */

// Starter Custom Code - next line - return type: StatusColor
const getAvailabilityColor = (productSettings: ProductSettingsModel, availability?: AvailabilityDto): StatusColor => {
    if (!productSettings.showInventoryAvailability) {
        return "neutral"; // Starter Custom Code
    }

    const availabilityType = availability?.messageType;
    if (availabilityType === AvailabilityMessageType.OutOfStock) {
        return "danger";
    }

    if (availabilityType === AvailabilityMessageType.LowStock) {
        return "warning";
    }

    return "success";
};

const getAvailabilityIcon = (productSettings: ProductSettingsModel, availability?: AvailabilityDto) => {
    if (!productSettings.showInventoryAvailability) {
        return {}; // Starter Custom Code
    }

    const availabilityType = availability?.messageType;
    if (availabilityType === AvailabilityMessageType.OutOfStock) {
        return { iconSrc: AlertTriangleFill, iconOffset: AlertTriangleFillOffset }; // Starter Custom Code
    }

    if (availabilityType === AvailabilityMessageType.LowStock) {
        return { iconSrc: AlertTriangleFill, iconOffset: AlertTriangleFillOffset }; // Starter Custom Code
    }

    return { iconSrc: CheckmarkCircle2Fill, iconOffset: CheckmarkCircle2FillOffset }; // Starter Custom Code
};

const showLink = (
    availability: AvailabilityDto | undefined,
    trackInventory: boolean,
    productSettings: ProductSettingsModel,
    isProductDetailsPage?: boolean,
): boolean => {
    if (
        !availability ||
        availability.messageType === AvailabilityMessageType.NoMessage ||
        !trackInventory ||
        !productSettings.showInventoryAvailability ||
        !productSettings.displayInventoryPerWarehouse
    ) {
        return false;
    }

    if (!productSettings.displayInventoryPerWarehouseOnlyOnProductDetail) {
        return true;
    }

    return !!isProductDetailsPage;
};

/* Store Custom Code - Start */
const showStatusFlowRender = (
    quantityOrdered: number | null | undefined,
    additionalResults: { [key: string]: string } | null | undefined,
    styles: ProductAvailabilityStyles,
    qtyOnHand: number | undefined,
    displayStockAmounts: boolean,
) => {
    const availabilityCode = additionalResults?.availabilityCode ?? "";
    const {
        inStockAmount,
        temporaryOutOfStockAmount,
        onDemandAmount,
        shouldShowInStock,
        shouldShowTemporaryOutOfStock,
        shouldShowOnDemand,
        shouldShowDiscontinued,
    } = useInventoryStatus(qtyOnHand, quantityOrdered, availabilityCode, additionalResults?.quantityOrdered);

    return (
        <StyledWrapper {...styles.inventoryMessage}>
            {shouldShowInStock && inStockAmount > 0 && (
                <>
                    <Typography {...styles.messageText} data-test-selector="availabilityMessage">
                        {displayStockAmounts && `${translate("InStock")} (${inStockAmount})`}
                        {!displayStockAmounts && `${translate("InStock")}`}
                    </Typography>

                    {availabilityCode !== storeConstants.availabilityCodes.Discontinued ? (
                        <Typography {...styles.additionnalMessageText}>
                            {additionalResults?.availabilityMessage}
                        </Typography>
                    ) : null}
                </>
            )}
            {shouldShowTemporaryOutOfStock && temporaryOutOfStockAmount > 0 && (
                <>
                    <Typography {...styles.messageText} data-test-selector="availabilityMessage">
                        {displayStockAmounts && `${translate("TemporaryOutofStock")} (${temporaryOutOfStockAmount})`}
                        {!displayStockAmounts && `${translate("TemporaryOutofStock")}`}
                    </Typography>
                    {availabilityCode !== storeConstants.availabilityCodes.Discontinued ? (
                        <Typography {...styles.additionnalMessageText}>
                            {additionalResults?.orderedAvailabilityMessage}
                        </Typography>
                    ) : null}
                </>
            )}
            {shouldShowOnDemand && (
                <>
                    <Typography {...styles.messageText} data-test-selector="availabilityMessage">
                        {displayStockAmounts && `${translate("OnDemand")} (${onDemandAmount})`}
                        {!displayStockAmounts && `${translate("OnDemand")}`}
                    </Typography>
                    {availabilityCode !== storeConstants.availabilityCodes.Discontinued ? (
                        <Typography {...styles.additionnalMessageText}>
                            {additionalResults?.onDemandAvailabilityMessage}
                            {additionalResults?.fastTrack && additionalResults?.fastTrack === "Y" ? (
                                <Typography {...styles.fastTrackAvailabilityMessageText}>
                                    {translate("fastTrackAvailabilityMessage")}
                                </Typography>
                            ) : null}
                        </Typography>
                    ) : null}
                </>
            )}
            {/* Custom Label */}
            {shouldShowDiscontinued && (
                <>
                    <Typography {...styles.messageText} data-test-selector="availabilityMessage">
                        {translate(storeConstants.availabilityCodes.Discontinued)}
                    </Typography>
                </>
            )}
        </StyledWrapper>
    );
};
/* Store Custom Code - End */

const ProductAvailability = ({
    productId,
    availability,
    unitOfMeasure,
    trackInventory,
    productSettings,
    isProductDetailsPage,
    getRealTimeWarehouseInventory,
    failedToLoadInventory,
    // Starter Removed - showInventory
    extendedStyles,
    // Starter Custom Code
    overridedStyles,
    // Store Custom Code
    quantityOrdered,
    additionalResults,
    qtyOnHand,
}: Props) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [warehouses, setWarehouses] = useState<WarehouseDto[] | undefined>(undefined);
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    /* Store Custom Code - Start */
    const { accountSettings } = useSettingsCollection();
    const { isAuthenticated, isGuest } = useSession();
    /* Store Custom Code - End */
    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };
    const viewAvailabilityByWarehouseClickHandler = () => {
        setIsLoading(true);
        setModalIsOpen(true);
        getRealTimeWarehouseInventory({
            productId,
            unitOfMeasure,
            expand: ["warehouses"],
            onComplete: result => {
                setWarehouses(result.warehouses);
                setErrorMessage(result.errorMessage);
                setIsLoading(false);
            },
        });
    };

    const color = getAvailabilityColor(productSettings, availability);
    const { iconSrc, iconOffset } = getAvailabilityIcon(productSettings, availability); // Starter Custom Code

    const showInventory = useShowProductAvailability(); // Starter Custom Code
    const styles = useExpandProps(productAvailabilityStyles, extendedStyles, overridedStyles); // Starter Custom Code
    /* Store Custom Code - Start */
    const inventoryTextComponent = useMemo(() => {
        return showStatusFlowRender(
            quantityOrdered,
            additionalResults,
            styles,
            qtyOnHand,
            accountSettings.allowGuestCheckout || (isAuthenticated && !isGuest), // Display inventory details to all if guest checkout is enabled, or only to loggedIn customers if guest checkout is not enabled.
        );
    }, [quantityOrdered, additionalResults, styles, qtyOnHand, accountSettings, isAuthenticated, isGuest]);
    /* Store Custom Code - End */
    if (!showInventory) {
        return null;
    }

    /* Starter Custom Code - Start */
    /* Store Custom Code - Start */
    const unavailableMessage = (
        <StyledWrapper {...styles.inventoryMessage}>
            <Typography {...styles.messageText} data-test-selector="availabilityMessage">
                {siteMessage("RealTimeInventory_InventoryLoadFailed")}
            </Typography>
        </StyledWrapper>
    );
    /* Store Custom Code - End */
    /* Starter Custom Code - End */

    if (failedToLoadInventory) {
        return <StyledWrapper {...styles.wrapper}>{unavailableMessage}</StyledWrapper>; // Starter Custom Code
    }
    /* Store Custom Code - Removed let inventoryTextComponent */

    /* Starter Removed - Grid */
    return (
        <StyledWrapper {...styles.wrapper /* Starter Custom Code */}>
            {inventoryTextComponent /* Starter Custom Code */}
            {showLink(availability, trackInventory, productSettings, isProductDetailsPage) && (
                <>
                    <Link
                        {...styles.availabilityByWarehouseLink}
                        onClick={viewAvailabilityByWarehouseClickHandler}
                        data-test-selector="availabilityByWarehouseLink"
                        title={translate("View Availability by Warehouse") /* Starter Custom Code */}
                    />
                    <Modal
                        {...styles.availabilityByWarehouseModal}
                        headline={translate("Warehouse Inventory")}
                        isOpen={modalIsOpen}
                        handleClose={modalCloseHandler}
                    >
                        {isLoading && <Loader /> /* Starter Custom Code */}
                        {!isLoading && (
                            <>
                                {errorMessage ? (
                                    <div>{errorMessage}</div>
                                ) : (
                                    <DataTable
                                        {...styles.availabilityByWarehouseTable}
                                        data-test-selector="availabilityByWarehouseModal"
                                    >
                                        <DataTableHead {...styles.availabilityByWarehouseTableHead}>
                                            <DataTableHeader {...styles.availabilityByWarehouseTableHeader}>
                                                {translate("Warehouse")}
                                            </DataTableHeader>
                                            <DataTableHeader {...styles.availabilityByWarehouseTableHeader}>
                                                {translate("QTY")}
                                            </DataTableHeader>
                                        </DataTableHead>
                                        <DataTableBody {...styles.availabilityByWarehouseTableBody}>
                                            {warehouses?.map(warehouse => (
                                                <DataTableRow
                                                    {...styles.availabilityByWarehouseTableRow}
                                                    key={warehouse.name}
                                                >
                                                    <DataTableCell
                                                        {...styles.availabilityByWarehouseTableCell}
                                                        data-test-selector="warehouseAvailabilityModal_Description"
                                                    >
                                                        {warehouse.description || warehouse.name}
                                                    </DataTableCell>
                                                    <DataTableCell
                                                        {...styles.availabilityByWarehouseTableCell}
                                                        data-test-selector="warehouseAvailabilityModal_Quantity"
                                                    >
                                                        {warehouse.qty}
                                                    </DataTableCell>
                                                </DataTableRow>
                                            ))}
                                        </DataTableBody>
                                    </DataTable>
                                )}
                            </>
                        )}
                    </Modal>
                </>
            )}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductAvailability);
